import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

import { canvasAabbForShapePanel } from '@/lib/shapes/shape-panel-bounds'

/** Union of per-shape rotated visual-box AABBs (same basis as single-object X/Y). */
export function multiSelectionCanvasUnionAabb(shapes: ShapeData[]): {
  minX: number
  minY: number
  maxX: number
  maxY: number
} {
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity

  for (const s of shapes) {
    const { minX: ax, minY: ay, maxX: aMaxX, maxY: aMaxY } = canvasAabbForShapePanel(s)

    if (ax < minX) minX = ax
    if (ay < minY) minY = ay
    if (aMaxX > maxX) maxX = aMaxX
    if (aMaxY > maxY) maxY = aMaxY
  }

  return { minX, minY, maxX, maxY }
}

/**
 * Object panel W/H for multi-select: use selection chrome local size (stable under rotation),
 * not the canvas-axis span of the union of rotated shape AABBs.
 */
export function multiSelectionPanelWidthHeight(params: {
  shapes: ShapeData[]
  shapeManager: ShapeManagerRef | null | undefined
}): { width: number; height: number } {
  const { shapes, shapeManager } = params

  if (shapes.length >= 2) {
    const chrome = shapeManager?.getMultiSelectChromeSnapshot?.() ?? null

    if (chrome && chrome.width > 0 && chrome.height > 0) {
      return { width: chrome.width, height: chrome.height }
    }
  }

  const union = multiSelectionCanvasUnionAabb(shapes)

  return {
    width: union.maxX - union.minX,
    height: union.maxY - union.minY,
  }
}
